import React from 'react'

import { FormValue } from '@/types'

import { FormlessFormField } from './FormField'
import { AnyObject } from './types'

export interface FormContext<T = AnyObject> {
	disabled: boolean
	enableFieldHighlight?: boolean
	getValues: () => Partial<T>
	id: string
	isHorizontal: boolean
	loading: boolean
	onFieldChange: (field: FormlessFormField<T>, value: FormValue) => void
	onFieldValidated: (field: string, valid: boolean) => void
	onFieldValidating: (field: string) => void
	register: (field: FormlessFormField<T>) => Promise<void>
	reset: (values?: Partial<T>) => void
	submitting: boolean
	unregister: (field: FormlessFormField<T>) => void
	valid: boolean
	validating: boolean
	withQueryString: boolean
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormContext = React.createContext<FormContext>(null as any)

FormContext.displayName = 'FormContext'

export const withForm = (Component: typeof React.Component) => {
	return class WithForm extends React.Component {
		render() {
			return (
				<FormContext.Consumer>
					{(context) => <Component form={context} {...this.props} />}
				</FormContext.Consumer>
			)
		}
	}
}
